
// Updated by: Halimunnisa
// Change: Allowed extraData.status to override pendingStatus.targetStatus during lead updates

import React from 'react';
import { AddLead } from "./AddLead";
import { ViewLead } from "./ViewLead";
import { ChangeStatusForm } from "./ChangeStatusForm";
import { UpdateAppointmentForm } from "../../Appointment Scheduled/components/UpdateAppointmentForm";

import { ConfirmationModal } from "@/components/ui";
import { leadService } from "../services/leadService";
import { siteVisitService } from "../../Site-Visit/services/siteVisitService";
import { showSuccessMessage, showErrorMessage, showApiError } from "@/lib/toast";

export const LeadsModals = ({
  // State variables
  isFormOpen,
  pendingStatus,
  isDetailOpen,
  confirmState,
  isAppointmentFormOpen,
  
  // State setters
  setIsFormOpen,
  setPendingStatus,
  setIsDetailOpen,
  setConfirmState,
  setIsAppointmentFormOpen,
  setSelectedLead,
  
  // Data
  activeLead,
  team,
  user,
  projectManagers,
  leadStages,
  
  // Methods
  handleLeadSubmit,
  refetch,
  toggleLeadStatus,
  handleUpdateLead,
  handleAppointmentSubmit,
}) => {
  return (
    <>
      <AddLead
        isOpen={isFormOpen}
        onClose={() => { setIsFormOpen(false); setSelectedLead(null); }}
        onSubmit={handleLeadSubmit}
        initialData={activeLead}
        teamMembers={team}
        user={user}
      />

      <ChangeStatusForm
        isOpen={!!pendingStatus}
        onClose={() => setPendingStatus(null)}
        onConfirm={async (extraData) => {
          if (!pendingStatus?.lead?._id) return;
          
          let response;
          const finalTargetStatus = extraData.status || pendingStatus.targetStatus;
          
          console.log("[DEBUG] LeadsModals onConfirm extraData:", extraData);
          console.log("[DEBUG] LeadsModals finalTargetStatus:", finalTargetStatus);
          
          if (pendingStatus.targetStatus === 'site_visit') {
            const payload = { ...extraData, status: finalTargetStatus };
            console.log("[DEBUG] LeadsModals payload for site_visit:", payload);
            response = await siteVisitService.submitSiteVisit(pendingStatus.lead._id, payload);
          } else {
            const payload = { ...extraData, status: finalTargetStatus };
            console.log("[DEBUG] LeadsModals payload for update:", payload);
            response = await leadService.update(pendingStatus.lead._id, payload);
          }

          const emailStatus = response?.data?.emailStatus || response?.emailStatus;
          if (emailStatus === 'sent') {
            showSuccessMessage("Status updated & Quotation sent!");
          } else if (emailStatus === 'invalid_address') {
            showErrorMessage("Status updated but Address not found! Please check the email address.");
          } else if (emailStatus === 'skipped') {
            showSuccessMessage("Status updated (Email skipped: No valid address). You can download and send it manually from the View modal.");
          } else if (emailStatus === 'failed') {
            showErrorMessage("Status updated but email failed to send. Please download manually from the View modal.");
          } else {
            showSuccessMessage("Status updated successfully");
          }

          setPendingStatus(null);
          refetch();
        }}
        pendingStatus={pendingStatus}
        teamMembers={team}
        stages={leadStages}
        user={user}
      />

      <ViewLead
        isOpen={isDetailOpen}
        onClose={() => { setIsDetailOpen(false); setSelectedLead(null); }}
        lead={activeLead}
        user={user}
        stages={leadStages}
        teamMembers={team}
        projectManagers={projectManagers}
        updateStatus={toggleLeadStatus}
        updateLeadState={handleUpdateLead}
        onToggleDisable={async (lead) => {
          const isEnabling = lead.isDisabled;
          setConfirmState({
            isOpen: true,
            title: isEnabling ? "Enable Lead" : "Disable Lead",
            message: `Are you sure you want to ${isEnabling ? 'enable' : 'disable'} this lead record?`,
            variant: isEnabling ? "info" : "danger",
            onConfirm: async () => {
              setConfirmState(prev => ({ ...prev, loading: true }));
              try {
                await leadService.toggleDisable(lead._id, !lead.isDisabled);
                showSuccessMessage(`Lead ${isEnabling ? 'enabled' : 'disabled'} successfully`);
                refetch();
              } catch (err) { showApiError(err); } finally { setConfirmState({ isOpen: false }); }
            }
          });
        }}
      />



      <ConfirmationModal
        isOpen={confirmState.isOpen}
        onClose={() => setConfirmState({ isOpen: false })}
        onConfirm={confirmState.onConfirm}
        title={confirmState.title}
        message={confirmState.message}
        variant={confirmState.variant}
        confirmText={confirmState.confirmText}
        loading={confirmState.loading}
      />


      <UpdateAppointmentForm
        isOpen={isAppointmentFormOpen}
        onClose={() => { setIsAppointmentFormOpen(false); setSelectedLead(null); }}
        onSubmit={handleAppointmentSubmit}
        initialData={activeLead}
      />
      

    </>
  );
};
